import $ from 'jquery';
import { util } from './app.js';
import input from './app.input.js';

const pagecontent = {
    Init: function () {
        this.BindContentEditor(document);
        $(document).on('component-bind-edit-mode-complete', function (e, component) {
            pagecontent.BindContentEditor(component.el);
        });
    },
    BindContentEditor: function (el) {
        $('.pagecontent-placeholder', $(el)).on('click', function () {
            $.ajax({
                url: '/Admin/PageContent/EditForm',
                data: {
                    mnemonic: $(this).data('pagecontentmnemonic'),
                    isTooltip: $(this).data('istooltip')
                },
                context: this,
                error: window.app.page.handleAjaxError
            }).done(function (data) {
                $('#pageContentModal #pageContentForm').html(data);
                util.openModal($('#pageContentModal'));
                input.initTextEditor($('#pageContentModal'));
            });
        });
    }
};

export default pagecontent;
